import { render, staticRenderFns } from "./CustomerList1.vue?vue&type=template&id=456b7bb4&scoped=true&"
import script from "./CustomerList1.vue?vue&type=script&lang=js&"
export * from "./CustomerList1.vue?vue&type=script&lang=js&"
import style0 from "./CustomerList1.vue?vue&type=style&index=0&id=456b7bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b7bb4",
  null
  
)

export default component.exports